import { Validated }				from "ts-base/validated";
import { Duration as BaseDuration }	from "ts-base/time/duration";

import { Numeric }	from "@v3/data/numeric";

// whole number of millliseconds since the unix epoch
export type Duration		= Numeric.Value<typeof Base>;

const Base	= Numeric.fromBase(BaseDuration, "must be a time difference in milliseconds");

namespace Extension {
	export const validateUnitString	= (it:string):Validated<string, Duration>	=>
		Validated.fromNullable(BaseDuration.fromUnitString(it))("must be a number followed by a unit of d, h, m, s or ms");
}

export const Duration	= { ...Extension, ...Base };
